import Service 			from "./../../Libs/Service";

let Banner = new Service({

	Name: "Banner",

	Libraries: [],

	Events: {

	},

	Actions: {

		//Получение проектов текущего издателя
		'BannerScriptChanged': function(bannerTemplateCodename) {

			if (Project.SelectedProject?.templateProps?.codename === bannerTemplateCodename) {

				Broadcast.call("Selected Banner Script Changed");

			}

		}

	},

	init() {

	}

});

//Делаем объект синглтоном чтобы при импортах возвращался тот же самый экземпляр
if (window.Banner) Banner = window.Banner;
else window.Banner = Banner;

export { Banner }

